import { cleanBassNotes, midiFrequency } from './bassVoice';
export const noteMidi = n => Math.round(69 + 12 * Math.log2(n.frequency / 440));
export function setNotePitch(note, pitch) {
  return {
    ...note,
    midiNote: pitch,
    frequency: midiFrequency(pitch)
  };
}
export function editBassNote(notes, id, patch, bars = 4) {
  const result = cleanBassNotes(notes.map(n => n.id === id ? {
    ...n,
    ...patch,
    slide: false
  } : n), bars);
  result.forEach((note, index) => {
    if (index > 0 && note.glideMs > 0) result[index - 1].durationSteps = note.step - result[index - 1].step;
  });
  return result;
}
export function glideInto(notes, id, ms) {
  const result = structuredClone(notes).sort((a, b) => a.step - b.step);
  const index = result.findIndex(n => n.id === id);
  if (index < 1) return result;
  const note = result[index],
    prev = result[index - 1];
  note.glideMs = ms;
  note.slide = false;
  if (ms > 0) prev.durationSteps = note.step - prev.step;
  return result;
}
export function bassVariation(notes, kind, bars = 4) {
  const source = cleanBassNotes(notes, bars);
  if (!source.length) return source;
  if (kind === 'simpler') return source.filter((n, i) => i % 2 === 0).map(n => ({
    ...n,
    glideMs: 0,
    slide: false
  }));
  if (kind === 'bounce') return source.map(n => ({
    ...n,
    durationSteps: Math.min(n.durationSteps, 1),
    glideMs: 0,
    slide: false
  }));
  const last = source[source.length - 1],
    start = bars * 16 - 4;
  const kept = source.filter(n => n.step < start).map(n => ({
    ...n,
    durationSteps: Math.min(n.durationSteps, start - n.step)
  }));
  return cleanBassNotes([...kept, ...[0, 2].map((s, i) => setNotePitch({
    ...last,
    id: `fill-${Date.now()}-${i}`,
    step: start + s,
    durationSteps: 1,
    glideMs: 0,
    slide: false
  }, noteMidi(last) + (i ? 0 : 12)))], bars);
}

/** Whole octaves keep the key, timing and deliberate glide intact. Saved clips are never auto-transposed. */
export function transposeBassOctave(notes, direction) {
  const delta = direction < 0 ? -12 : 12;
  if ((notes || []).some(note => noteMidi(note) + delta < 12 || noteMidi(note) + delta > 72)) return notes;
  return notes.map(note => setNotePitch(note, noteMidi(note) + delta));
}
export function glidePreviewNotes(notes, id, glideMs, bars = 4) {
  const sorted = cleanBassNotes(notes, bars);
  const index = sorted.findIndex(note => note.id === id);
  if (index < 1 || Math.abs(sorted[index].frequency - sorted[index - 1].frequency) < .01) return null;
  return [{
    ...sorted[index - 1],
    step: 0,
    durationSteps: 4,
    glideMs: 0,
    slide: false
  }, {
    ...sorted[index],
    step: 4,
    durationSteps: 8,
    glideMs,
    slide: false
  }];
}
